"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var AbstractValidationPlugin_1 = __importDefault(require("./AbstractValidationPlugin"));
console.debug('INFO RequiredValidatonPlugin.ts loaded');
var RequiredValidationPlugin = /** @class */ (function (_super) {
    __extends(RequiredValidationPlugin, _super);
    function RequiredValidationPlugin(field) {
        var _this = _super.call(this, field) || this;
        _this.field = field;
        return _this;
    }
    RequiredValidationPlugin.prototype.isValid = function () {
        if (this.field.getAttribute('type') !== 'checkbox') {
            return !this.field.validity.valueMissing;
        }
        else {
            var name_1 = this.field.getAttribute('name');
            return document.querySelectorAll("[name='".concat(name_1, "']:checked")).length > 0;
        }
    };
    RequiredValidationPlugin.prototype._getMessageAttribute = function () {
        return 'data-required-error-message';
    };
    RequiredValidationPlugin.prototype._getDefaultMessage = function () {
        if (this.field.tagName === 'SELECT' || this.field.getAttribute('type') === 'radio') {
            return 'Please choose an option.';
        }
        else if (this.field.getAttribute('type') === 'checkbox') {
            return 'Please confirm the checkbox.';
        }
        return 'This field is required and needs to be filled out.';
    };
    return RequiredValidationPlugin;
}(AbstractValidationPlugin_1.default));
exports.default = RequiredValidationPlugin;
